/**
 * PageHeader — Page-level heading with optional subtitle.
 *
 * Props:
 *   title: string — main heading (uses display font)
 *   subtitle: string — secondary text
 *   actions: ReactNode — right-aligned action buttons (optional)
 */

import React from 'react';
import styles from './PageHeader.module.css';

function PageHeader({ title, subtitle, actions }) {
  return (
    <div className={styles.header}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export default PageHeader;
